var map = {
	"./de/coefficients": [
		"aTKs",
		60
	],
	"./en/coefficients": [
		"EMM5",
		44
	],
	"./fr/coefficients": [
		"RnGy",
		28
	],
	"./nl/coefficients": [
		"I3wH",
		12
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "dNs6";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang lazy ^\.\/.*\/coefficients$
// module id = dNs6
// module chunks = 97